export default {
    slug: 'zirconia-crowns-bridges',
    img: '/img/tr-zirconia.jpg',
    icon: 'crown',
    en: {
        name: 'Zirconia Crowns & Bridges',
        short: 'Strong, metal-free ceramic restorations — planned carefully.',
        metaTitle: 'Zirconia Crown & Bridge in Johor Bahru | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Zirconia crowns and bridges in Johor Bahru for broken, heavily restored or missing teeth. Crown vs bridge explained simply, with transparent fees.',
        kicker: 'Restorative',
        heroTitle: 'Strong, metal-free ceramic — for teeth that need protection or replacement.',
        heroSub: 'Zirconia is a tooth-coloured ceramic used for crowns and bridges. Here is what a crown and a bridge actually do — and how we decide, with you, what is appropriate.',
        whoIntro: 'Patients who consider zirconia work usually have:',
        who: [
            'A broken or heavily restored tooth that needs protection',
            'A missing tooth where a bridge may be considered',
            'Concerns about the look of metal-based restorations',
            'A wish to restore comfortable chewing',
        ],
        problem: 'A crown covers and protects a damaged tooth. A bridge replaces a missing tooth by anchoring to neighbouring teeth. Zirconia is a strong, tooth-coloured ceramic. Whether zirconia — versus other materials — is right for you is an individual clinical decision, made at assessment.',
        assessmentIntro: 'How we assess:',
        assessment: [
            'An examination of the tooth or gap, the supporting teeth and your bite',
            'Records where clinically needed',
            'A plain-language explanation of crown vs bridge — and which fits your case',
            'A material discussion without exaggeration: what zirconia does well, and what other options offer',
            'Fees explained in writing before anything is decided',
        ],
        optionsIntro: 'The choices we discuss at assessment:',
        options: [
            { name: 'Zirconia crown', text: 'Covers and protects a tooth that is broken or heavily restored, in a tooth-coloured ceramic.' },
            { name: 'Zirconia bridge', text: 'Replaces a missing tooth by anchoring a ceramic tooth to neighbouring teeth — considered case by case.' },
            { name: 'Other materials and options', text: 'Zirconia is not automatically superior to every other material for every case. We discuss the trade-offs honestly.' },
        ],
        knowIntro: 'What patients should know:',
        know: [
            'Crown and bridge work requires careful assessment of the supporting teeth and your bite',
            'Shade and shaping are planned to blend with your natural teeth',
            'Longevity varies by case, material and home care — no honest dentist quotes a fixed lifespan without examining you',
        ],
        followup: 'Crowns and bridges are reviewed at routine visits. Anything that feels different — a change in bite or a sensitive tooth — deserves a quick call to the clinic.',
        faqs: [
            { q: 'What is the difference between a crown and a bridge?', a: 'A crown covers and protects one existing tooth. A bridge replaces a missing tooth by anchoring to the teeth beside the gap. Which one fits your case is decided at assessment.' },
            { q: 'How long does a zirconia bridge last?', a: 'It varies by case, bite and home care. No honest dentist quotes a fixed lifespan without examining you — we will tell you what your specific situation suggests.' },
            { q: 'Is zirconia better than other materials?', a: 'Not automatically. Zirconia has strengths — strength and aesthetics — but other materials suit certain cases better. We discuss trade-offs without exaggeration.' },
            { q: 'Will getting a crown hurt?', a: 'Treatment is done under local anaesthesia and planned gently, but every mouth is different. We explain what to expect before anything begins.' },
        ],
        intlNote: 'Selected restorative treatments — including zirconia crowns and bridges — are among the reasons patients from Indonesia/Batam visit the clinic. See the Indonesia/Batam page.',
    },
    ms: {
        name: 'Zirconia Crown & Bridge',
        short: 'Restorasi seramik yang kuat tanpa logam — dirancang teliti.',
        metaTitle: 'Zirconia Crown & Bridge di Johor Bahru | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Zirconia crown dan bridge di Johor Bahru untuk gigi patah, banyak ditampal atau hilang. Beza crown dan bridge dijelaskan dengan mudah, yuran telus.',
        kicker: 'Restoratif',
        heroTitle: 'Seramik yang kuat tanpa logam — untuk gigi yang memerlukan perlindungan atau penggantian.',
        heroSub: 'Zirconia ialah seramik warna gigi untuk crown dan bridge. Ini apa yang crown dan bridge sebenarnya lakukan — dan bagaimana kami memutuskan bersama anda apa yang sewajarnya.',
        whoIntro: 'Pesakit yang mempertimbangkan zirconia biasanya mempunyai:',
        who: [
            'Gigi patah atau banyak ditampal yang memerlukan perlindungan',
            'Gigi hilang di mana bridge mungkin dipertimbangkan',
            'Kekhuatiran tentang rupa restorasi berasaskan logam',
            'Ingin memulihkan kunyahan yang selesa',
        ],
        problem: 'Crown melindungi gigi yang rosak. Bridge menggantikan gigi yang hilang dengan bertumpu pada gigi bersebelahan. Zirconia ialah seramik warna gigi yang kuat. Sama ada zirconia — berbanding bahan lain — sesuai untuk anda ialah keputusan klinikal individu pada penilaian.',
        assessmentIntro: 'Bagaimana kami menilai:',
        assessment: [
            'Pemeriksaan gigi atau ruang, gigi sokongan dan gigitan anda',
            'Rekod di mana perlu secara klinikal',
            'Penjelasan mudah crown vs bridge — dan yang mana sesuai untuk kes anda',
            'Perbincangan bahan tanpa pujian berlebihan: apa yang zirconia lakukan dengan baik, dan apa yang ditawarkan pilihan lain',
            'Yuran diterangkan secara bertulis sebelum apa-apa diputuskan',
        ],
        optionsIntro: 'Pilihan yang kami bincangkan pada penilaian:',
        options: [
            { name: 'Zirconia crown', text: 'Melindungi gigi yang patah atau banyak ditampal, dengan seramik warna gigi.' },
            { name: 'Zirconia bridge', text: 'Menggantikan gigi hilang dengan bertumpu pada gigi bersebelahan — dipertimbangkan kes demi kes.' },
            { name: 'Bahan dan pilihan lain', text: 'Zirconia tidak semestinya lebih baik daripada setiap bahan lain untuk setiap kes. Kami bincangkan pertukarannya dengan jujur.' },
        ],
        knowIntro: 'Apa yang pesakit patut tahu:',
        know: [
            'Kerja crown dan bridge memerlukan penilaian teliti terhadap gigi sokongan dan gigitan anda',
            'Warna dan bentuk dirancang agar serasi dengan gigi asli anda',
            'Ketahanan berbeza mengikut kes, bahan dan penjagaan — tiada doktor yang jujur memberi jangka hayat tetap tanpa memeriksa',
        ],
        followup: 'Crown dan bridge disemak pada lawatan berkala. Apa sahaja yang terasa berbeza — gigitan atau sensitiviti — patut diberitahu kepada klinik.',
        faqs: [
            { q: 'Apa beza crown dan bridge?', a: 'Crown melindungi satu gigi sedia ada. Bridge menggantikan gigi yang hilang dengan bertumpu pada gigi di sebelah ruangnya. Yang mana sesuai diputuskan pada penilaian.' },
            { q: 'Berapa lama zirconia bridge tahan?', a: 'Ia berbeza mengikut kes, gigitan dan penjagaan. Tiada doktor yang jujur memberi jangka hayat tetap tanpa memeriksa — kami beritahu apa yang situasi anda tunjukkan.' },
            { q: 'Adakah zirconia lebih baik daripada bahan lain?', a: 'Tidak semestinya. Zirconia ada kekuatannya — kekuatan dan estetik — tetapi bahan lain lebih sesuai untuk kes tertentu. Kami bincangkan tanpa pujian berlebihan.' },
            { q: 'Adakah pemasangan crown menyakitkan?', a: 'Rawatan dilakukan di bawah bius setempat dan dirancang dengan lembut, tetapi setiap mulut berbeza. Kami terangkan apa yang dijangkakan sebelum bermula.' },
        ],
        intlNote: 'Rawatan restoratif terpilih — termasuk zirconia crown dan bridge — antara sebab pesakit dari Indonesia/Batam datang ke klinik. Lihat halaman Indonesia/Batam.',
    },
    zh: {
        name: '氧化锆牙冠与牙桥',
        short: '坚固、无金属的陶瓷修复 —— 细心规划。',
        metaTitle: '新山氧化锆牙冠与牙桥 | Irma Ariandi 牙科诊所',
        metaDesc: '新山氧化锆牙冠与牙桥 —— 断裂、大面积补牙或缺失牙齿的修复。简单解释牙冠与牙桥的区别，收费透明。',
        kicker: '修复治疗',
        heroTitle: '坚固、无金属的陶瓷 —— 用于需要保护或替换的牙齿。',
        heroSub: '氧化锆是一种牙色陶瓷，用于牙冠与牙桥。这里讲清楚牙冠和牙桥到底做什么 —— 以及如何与您一起判断哪种方案合适。',
        whoIntro: '考虑氧化锆修复的患者通常：',
        who: [
            '断裂或大面积补过的牙齿需要保护',
            '牙齿缺失，或可考虑牙桥',
            '担心金属修复体的外观',
            '希望恢复舒适的咀嚼功能',
        ],
        problem: '牙冠覆盖并保护受损的牙齿；牙桥通过邻牙支撑来替代缺失的牙齿。氧化锆是一种坚固的牙色陶瓷。氧化锆与其他材料相比是否适合您 —— 这是评估时做出的个体化临床决定。',
        assessmentIntro: '我们的评估包括：',
        assessment: [
            '检查患牙或缺牙间隙、支撑牙与咬合',
            '临床需要时拍摄记录',
            '用大白话解释牙冠与牙桥的区别 —— 以及哪一种适合您的情况',
            '不过度吹捧的材料讨论：氧化锆擅长什么，其他选项提供什么',
            '在决定之前，书面解释收费',
        ],
        optionsIntro: '评估时讨论的选择：',
        options: [
            { name: '氧化锆冠', text: '以牙色陶瓷覆盖并保护破损或大面积修复的牙齿。' },
            { name: '氧化锆桥', text: '通过在邻牙上固定陶瓷牙来替代缺失牙 —— 按个案评估。' },
            { name: '其他材料与选择', text: '氧化锆并非对每个病例都优于其他材料。我们会诚实讨论取舍。' },
        ],
        knowIntro: '患者须知：',
        know: [
            '牙冠与牙桥需要仔细评估支撑牙与咬合',
            '颜色与形态会按您的天然牙进行匹配设计',
            '耐用度因病例、材料与家庭护理而异 —— 不检查就报固定年限不是诚实的做法',
        ],
        followup: '牙冠与牙桥在常规复诊中复查。任何异样 —— 咬合变化或牙齿敏感 —— 都值得给诊所打个电话。',
        faqs: [
            { q: '牙冠和牙桥有什么区别？', a: '牙冠覆盖并保护一颗已有的牙齿；牙桥通过缺牙间隙两侧的牙齿支撑，替代缺失的牙。哪种适合您，在评估时确定。' },
            { q: '氧化锆牙桥能用多久？', a: '因病例、咬合与家庭护理而异。不检查就报固定年限不是诚实的做法 —— 我们会说明您的情况预示什么。' },
            { q: '氧化锆一定比其他材料好吗？', a: '不一定。氧化锆有它的长处 —— 强度与美观 —— 但某些病例用其他材料更合适。我们会不带夸张地讨论利弊。' },
            { q: '做牙冠会痛吗？', a: '治疗在局部麻醉下进行，安排得尽量温和，但每口牙都不同。开始前我们会解释预期。' },
        ],
        intlNote: '精选修复治疗（包括氧化锆牙冠与牙桥）是印尼/巴淡岛患者来诊所的原因之一。请查看印尼/巴淡岛专页。',
    },
    ta: {
        name: 'சிர்க்கோனியா கிரீடம் & பிரிட்ஜ்',
        short: 'வலுவான, உலோகமற்ற செராமிக் மீட்டமைப்பு.',
        metaTitle: 'ஜொகூர் பாருவில் சிர்க்கோனியா கிரீடம் & பிரிட்ஜ் | இர்மா அரியாண்டி',
        metaDesc: 'உடைந்த, அதிகம் நிரப்பப்பட்ட அல்லது இல்லாத பற்களுக்கு சிர்க்கோனியா கிரீடம் மற்றும் பிரிட்ஜ்.',
        kicker: 'மீட்டமைப்பு',
        heroTitle: 'வலுவான, உலோகமற்ற செராமிக் — பாதுகாப்பு அல்லது மாற்று தேவைப்படும் பற்களுக்கு.',
        heroSub: 'சிர்க்கோனியா என்பது கிரீடம் மற்றும் பிரிட்ஜ்களுக்குப் பயன்படும் பல் நிற செராமிக். கிரீடமும் பிரிட்ஜும் என்ன செய்கின்றன என்பது இதோ.',
        whoIntro: 'சிர்க்கோனியா கருதும் நோயாளிகள்:',
        who: [
            'பாதுகாப்பு தேவைப்படும் உடைந்த/அதிகம் நிரப்பப்பட்ட பல்',
            'பிரிட்ஜ் கருதப்படக்கூடிய இல்லாத பல்',
            'உலோக மீட்டமைப்பின் தோற்றம் குறித்த கவலை',
            'வசதியான மெல்லுதலை மீட்டமைக்க விருப்பம்',
        ],
        problem: 'கிரீடம் ஒரு சேதமான பல்லை மூடிப் பாதுகாக்கும்; பிரிட்ஜ் அண்டைப் பற்களின் மீது நின்று இல்லாத பல்லை மாற்றும். சிர்க்கோனியா பொருத்தமா என்பது மதிப்பீட்டில் முடிவெடுக்கப்படும் மருத்துவ முடிவு.',
        assessmentIntro: 'எங்கள் மதிப்பீடு:',
        assessment: [
            'பல்/இடைவெளி, தாங்கும் பற்கள், கடித்தல் பரிசோதனை',
            'கிரீடம் vs பிரிட்ஜ் — எளிய மொழியில் விளக்கம்',
            'முடிவுக்கு முன்பே கட்டணம் எழுத்தில் விளக்கம்',
        ],
        optionsIntro: 'மதிப்பீட்டில் விவாதிக்கும் விருப்பங்கள்:',
        options: [
            { name: 'Zirconia crown', text: 'உடைந்த அல்லது பெரிதும் நிரப்பப்பட்ட பல்லை பல் நிற செராமிக்கால் மூடிப் பாதுகாக்கிறது.' },
            { name: 'Zirconia bridge', text: 'விடுபட்ட பல்லை அண்டைப் பற்களில் செராமிக் பல்லை இணைத்து மாற்றுகிறது — வழக்கு வாரியாகப் பரிசீலனை.' },
            { name: 'மற்ற பொருட்கள் மற்றும் விருப்பங்கள்', text: 'ஒவ்வொரு நிலைக்கும் zirconia தானாகவே சிறந்தது அல்ல. நன்மை-தீமைகளை நேர்மையாக விவாதிப்போம்.' },
        ],
        knowIntro: 'நோயாளிகள் அறிந்திருக்க வேண்டியவை:',
        know: [
            'தாங்கும் பற்கள் மற்றும் கடித்தல் கவனமாக மதிப்பிடப்பட வேண்டும்',
            'இயற்கைப் பற்களுடன் இசையுமாறு நிறம் வடிவம் திட்டமிடப்படும்',
            'ஆயுள் வழக்கு, பொருள், பராமரிப்பைப் பொறுத்தது',
        ],
        followup: 'கடித்தல் அல்லது உணர்ச்சியில் மாற்றம் கண்டால் கிளினிக்கைத் தொடர்பு கொள்ளுங்கள்.',
        faqs: [
            { q: 'கிரீடமும் பிரிட்ஜும் எப்படி வேறுபடும்?', a: 'கிரீடம் ஒரு உள்ள பல்லை மூடிப் பாதுகாக்கும்; பிரிட்ஜ் இல்லாத பல்லை அண்டைப் பற்களின் மீது மாற்றும்.' },
            { q: 'சிர்க்கோனியா பிரிட்ஜ் எவ்வளவு காலம் நீடிக்கும்?', a: 'வழக்கு, கடித்தல், பராமரிப்பைப் பொறுத்தது; பரிசோதனையின்றி உறுதியான எண் இல்லை.' },
            { q: 'சிர்க்கோனியா எப்போதும் சிறந்ததா?', a: 'தானாக இல்லை. சில நிலைகளில் பிற பொருட்கள் பொருத்தமானவை; நாங்கள் நேர்மையாக விளக்குவோம்.' },
        ],
        intlNote: 'இந்தோனேசியா/பத்தாம் நோயாளிகள் சிர்க்கோனியா சிகிச்சைக்காகவும் வருகிறார்கள்.',
    },
};
